export class School {
    name: string
    address: string
    city: string
    state: any
    zipCode: string

    constructor(response) {
        this.name = response.school_name || ""
        this.address = response.school_address || ""
        this.city = response.school_city || ""
        this.state = response.school_state || {}
        this.zipCode = response.school_zip || ""
    }

    public generateApiPayload(): string {
        const payload =
            "school_name=" +
            this.name +
            "&school_address=" +
            this.address +
            "&school_city=" +
            this.city +
            "&school_state=" +
            this.state.abbreviation +
            "&school_zip=" +
            this.zipCode

        return payload
    }
}
